import { EntitySummaries } from '@/types';
import { createActionCreator } from 'deox';

export const fetchSummaryActions = {
  request: createActionCreator(
    'FETCH_SUMMARY_REQUEST',
    (resolve) => (
      region: string,
      country: string,
      entityTypes: string,
      complianceGroups: string,
      apiCategories: string,
      appFeatures: string,
      includeCountries?: boolean,
      features?: string
    ) =>
      resolve({
        region,
        country,
        entityTypes,
        complianceGroups,
        apiCategories,
        appFeatures,
        includeCountries,
        features,
      })
  ),
  success: createActionCreator('FETCH_SUMMARY_SUCCESS', (resolve) => (data: EntitySummaries) => resolve(data)),
  failure: createActionCreator('FETCH_SUMMARY_FAILURE', (resolve) => (error: Error) => resolve({ error })),
};

export const clearSummaryAction = {
  request: createActionCreator('CLEAR_SUMMARY'),
};
